import type { CSSProperties, ReactNode } from "react";

import { cx, styled } from "simplydo/react/styled";

import { headingBaseClass } from "./Header.styles";

export type HeadingProps = {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
};

const StyledH1 = styled.h1`
  font-size: 2rem;
`;

const StyledH2 = styled.h2`
  font-size: 1.71428571rem;
`;

const StyledH3 = styled.h3`
  font-size: 1.28571429rem;
`;

const StyledH4 = styled.h4`
  font-size: 1.07142857rem;
`;

const StyledH5 = styled.h5`
  font-size: 1rem;
`;

const StyledH6 = styled.h6`
  font-size: 0.92857143rem;
`;

export const H1 = ({ children, className, style }: HeadingProps) => (
  <StyledH1 className={cx(headingBaseClass, className)} style={style}>
    {children}
  </StyledH1>
);

export const H2 = ({ children, className, style }: HeadingProps) => (
  <StyledH2 className={cx(headingBaseClass, className)} style={style}>
    {children}
  </StyledH2>
);

export const H3 = ({ children, className, style }: HeadingProps) => (
  <StyledH3 className={cx(headingBaseClass, className)} style={style}>
    {children}
  </StyledH3>
);

export const H4 = ({ children, className, style }: HeadingProps) => (
  <StyledH4 className={cx(headingBaseClass, className)} style={style}>
    {children}
  </StyledH4>
);

export const H5 = ({ children, className, style }: HeadingProps) => (
  <StyledH5 className={cx(headingBaseClass, className)} style={style}>
    {children}
  </StyledH5>
);

export const H6 = ({ children, className, style }: HeadingProps) => (
  <StyledH6 className={cx(headingBaseClass, className)} style={style}>
    {children}
  </StyledH6>
);

export const JustifiedHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  margin-bottom: 1rem;

  &:only-child {
    margin-bottom: 0;
  }

  .${headingBaseClass} {
    margin: 0;
  }
`;
